<template lang="pug">
div
  div(v-if="!whiteLabel" :class="{ 'landing bt': brand == 'BT', 'landing': brand == 'IBCBET1' }")
    //- loginModal
    //- #video-modal.modal.fade.video-modal.show(tabindex='-1' role='dialog' aria-labelledby='loginLabel' aria-modal='true'), 'landing2': !['UBETT','IBCBET'].includes(brand)
    //-   .modal-dialog(role='document')
    //-     .modal-content
    //-       iframe(src='https://www.youtube.com/embed/eOsdB7HHADc' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen='')
    template(v-if='q && q.hasOwnProperty("u") && q.hasOwnProperty("p")')
      .landing.white-label
          .preloader
            .loader
            .logo
              .d-block
                span {{ result }}
    template(v-else)
      tutorialModal
      router-view
  .landing.white-label(v-else)
    .preloader
      .loader
      .logo
        .d-block(v-if="!whiteLabel")
          img(v-if="cnyMode" :src="logoCNYPath")
          img(v-else-if="xmasMode" :src="logoXMASPath")
          img(v-else :src="logoPath")
          //- img(src="/images/logo/logo_cny.png?v=12")
        .d-block
          span {{ result }}
</template>

<script>
// import loginModal from "@/components/mobile/loginModal";
import tutorialModal from "@/components/mobile/account/tutorialModal";
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    // loginModal,
    tutorialModal
  },
  data() {
    return {
      whiteLabel: false,
      token: "",
      lang: config.defaultLang,
      theme: "",
      oddsType: "",
      feedback: {
        username: "",
        password: "",
        loading: false,
        timeout: null
      },
      result: "",
      loading: true,
      loader: true,
      q: null,
    }
  },
  computed: {
    brand() {
      return config.brand;
    },
    logoPath() {
      return config.logoPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    xmasMode() {
      return config.xmasMode;
    },
    logoXMASPath() {
      return config.logoXMASPath;
    },
    isWhiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  created() {
    window.addEventListener("load", event => {
      window.addEventListener("appinstalled", event => {
        console.log("PWA app installed by user!!! Hurray");
      });
    });
  },
  mounted() {
    this.result = "Establish connection...";
    this.q = this.$route.query;
    this.launch(this.q);
    // if (q.a) {
    //   this.$store.dispatch("user/clear");
    //   this.token = q.a;
    //   this.whiteLabel = true;
    //   switch (q.lang.toLowerCase()) {
    //     case "cn":
    //     case "th":
    //     case "vi":
    //     case "kr":
    //     case "id":
    //     case "jp":
    //       this.lang = q.lang.toLowerCase();
    //       break;
    //     default:
    //       this.lang = config.defaultLang;
    //       break;
    //   }
    //   if(q.theme) {
    //     switch (q.theme.toLowerCase()) {
    //       case "color1":
    //       case "color2":
    //       case "color3":
    //       case "color4":
    //         this.theme = q.theme.toLowerCase();
    //         break;
    //       default:
    //         this.theme = "color2";
    //         break;
    //     }
    //   } else {
    //     this.theme = "color2";
    //   }
    //   if (q.ot) {
    //     switch (q.ot.toUpperCase()) {
    //       case "MY":
    //       case "HK":
    //       case "ID":
    //       case "DEC":
    //         this.oddsType = q.ot.toUpperCase();
    //         break;
    //       default:
    //         this.oddsType = config.defaultOdds;
    //         break;
    //     }
    //   }
    //   this.result = "Establish connection...";
    //   this.$store.dispatch("layout/setLanguage", this.lang);
    //   this.$store.dispatch("layout/setTheme", this.theme);
    //   if (this.isWhiteLabel) {
    //     setTimeout(() => {
    //       this.result = "Authenticate user account...";
    //       this.$store.dispatch("layout/reset");
    //       this.$store.dispatch("user/doLaunch", this.token).then(
    //         res => {
    //           this.feedback.loading = false;
    //           if (res.success) {
    //             this.feedback.loading = true;
    //             this.$store.dispatch("user/getBalance").then(
    //               res => {
    //                 this.feedback.loading = false;
    //                 if (res.success) {
    //                   this.$store.dispatch("layout/setRadarId", null);
    //                   // this.$store.dispatch("layout/setSingleBetting", { property: "quickBet", value: false });

    //                   if (this.oddsType != null && this.oddsType != "") {
    //                     this.$store.dispatch("layout/setOddsType", this.oddsType);
    //                   }

    //                   if (q.match && q.sports && q.market) {
    //                     var mi5 = {};
    //                     mi5["menuX"] = false;
    //                     mi5["menuY"] = "0";
    //                     switch (q.market) {
    //                       case 1:
    //                         mi5["menu1"] = "early";
    //                         break;
    //                       case 2:
    //                         mi5["menu1"] = "today";
    //                         break;
    //                       case 3:
    //                         mi5["menu1"] = "today";
    //                         break;
    //                     }
    //                     mi5["menu3"] = "hdpou";
    //                     mi5["menu0"] = "all";
    //                     mi5["menu2"] = parseInt(q.sports);
    //                     this.$store.dispatch("layout/setMenuItems", mi5);
    //                     this.$store.dispatch("layout/setSelectedMatch", q.match)
    //                     EventBus.$emit("GET_MATCH2")
    //                     this.$router.push("/more").catch(err => {})
    //                   } else if (q.hl && q.hl == 1) {
    //                     this.$router.push("/highlight").catch(err => {});
    //                   } else {
    //                     var mi5 = {};
    //                     mi5["menuX"] = false;
    //                     mi5["menuY"] = "0";
    //                     mi5["menu0"] = "live";
    //                     mi5["menu1"] = "live";
    //                     mi5["menu2"] = parseInt(1);
    //                     mi5["menu3"] = "hdpou";
    //                     var options = {};
    //                     options[mi5["menu2"]] = true;
    //                     this.$store.dispatch("layout/setOptions", { property: "live", value: options });
    //                     this.$store.dispatch("layout/setMenuItems", mi5);
    //                     EventBus.$emit("INVALIDATE");
    //                     this.$router.push("/prematch").catch(err => {
    //                       console.trace(err);
    //                     });
    //                   }
    //                 } else {
    //                   this.result = this.$t("error." + res.status);
    //                   if (this.$helpers.handleFeedback(res.status)) {
    //                   }
    //                 }
    //               },
    //               err => {
    //                 this.feedback.loading = false;
    //                 this.result = this.$t("error." + res.status);
    //                 if (this.$helpers.handleFeedback(err.status)) {
    //                 }
    //               }
    //             );
    //           } else {
    //             this.result = this.$t("error." + res.status);
    //             this.$helpers.handleFeedback(res.status);
    //           }
    //         },
    //         err => {
    //           this.feedback.loading = false;
    //           this.result = this.$t("error." + err.status);
    //           this.$helpers.handleFeedback(err.status);
    //         }
    //       );
    //     }, 2000);
    //   } else {
    //     this.result = "Function not supported!";
    //   }
    // } else {
    //   var context = q;
    //   this.doSwitch(context);
    // }
  },
  methods: {
    launch(q, redirectURL) {
      if (q.hasOwnProperty("a")) {
        // White Label token login
        //
        this.doWhiteLabel(q, redirectURL);
      } else if (q.hasOwnProperty("u") && q.hasOwnProperty("st")) {
        // Switch between Desktop and Mobile
        //
        this.doSwitch(q, redirectURL);
      } else if (q.hasOwnProperty("u") && q.hasOwnProperty("p")) {
        // URL Login
        //
        this.doLogin(q, redirectURL);
      } else {
        // Normal User Login
        //
        // setTimeout(() => {
        //   this.loader = false;
        //   this.loading = false;
        //   if (q.view) {
        //   } else {
        //     if (this.isMobileTablet()) {
        //       var domain = this.getDomain(window.location.hostname, false);
        //       var test = "https://m." + domain;
        //       window.location.href = test;
        //     }
        //   }
        // }, 1000);
      }
    },
    doWhiteLabel(q, redirectURL) {
      this.$store.dispatch("user/clear");
      this.token = q.a;
      this.whiteLabel = true;
      switch (q.lang.toLowerCase()) {
        case "cn":
        case "th":
        case "vi":
        case "kr":
        case "id":
        case "jp":
        case "en":
        case "my":
          this.lang = q.lang.toLowerCase();
          break;
        default:
          this.lang = config.defaultLang;
          break;
      }
      if(q.theme) {
        switch (q.theme.toLowerCase()) {
          case "color1":
          case "color2":
          case "color3":
          case "color4":
          case "color5":
            this.theme = q.theme.toLowerCase();
            break;
          default:
            this.theme = "color2";
            break;
        }
      } else {
        this.theme = "color2";
      }
      if (q.ot) {
        switch (q.ot.toUpperCase()) {
          case "MY":
          case "HK":
          case "ID":
          case "DEC":
            this.oddsType = q.ot.toUpperCase();
            break;
          default:
            this.oddsType = config.defaultOdds;
            break;
        }
      }
      this.result = "Establish connection...";
      this.$store.dispatch("layout/setLanguage", this.lang);
      this.$store.dispatch("layout/setTheme", this.theme);
      if (this.isWhiteLabel) {
        setTimeout(() => {
          this.result = "Authenticate user account...";
          this.$store.dispatch("layout/reset");
          this.$store.dispatch("user/doLaunch", this.token).then(
            res => {
              this.feedback.loading = false;
              if (res.success) {
                this.feedback.loading = true;
                this.$store.dispatch("user/getBalance").then(
                  res => {
                    this.feedback.loading = false;
                    if (res.success) {
                      this.$store.dispatch("layout/setRadarId", null);
                      // this.$store.dispatch("layout/setSingleBetting", { property: "quickBet", value: false });

                      if (this.oddsType != null && this.oddsType != "") {
                        this.$store.dispatch("layout/setOddsType", this.oddsType);
                      }

                      if (redirectURL) {
                        this.$router
                          .push(redirectURL)
                          .then((res) => {
                            EventBus.$emit("INVALIDATE");
                          })
                          .catch((err) => {
                            console.trace(err);
                          });
                      } else {
                        if (q.match && q.sports && q.market) {
                          var mi5 = {};
                          mi5["menuX"] = false;
                          mi5["menuY"] = "0";
                          switch (q.market) {
                            case 1:
                              mi5["menu1"] = "early";
                              break;
                            case 2:
                              mi5["menu1"] = "today";
                              break;
                            case 3:
                              mi5["menu1"] = "today";
                              break;
                          }
                          mi5["menu3"] = "hdpou";
                          mi5["menu0"] = "all";
                          mi5["menu2"] = parseInt(q.sports);
                          this.$store.dispatch("layout/setMenuItems", mi5);
                          this.$store.dispatch("layout/setSelectedMatch", q.match)
                          EventBus.$emit("GET_MATCH2")
                          this.$router.push("/more").catch(err => {})
                        } else if (q.hl && q.hl == 1) {
                          this.$router.push("/highlight").catch(err => {});
                        } else {
                          var mi5 = {};
                          mi5["menuX"] = false;
                          mi5["menuY"] = "0";
                          mi5["menu0"] = "live";
                          mi5["menu1"] = "live";
                          mi5["menu2"] = parseInt(1);
                          mi5["menu3"] = "hdpou";
                          var options = {};
                          options[mi5["menu2"]] = true;
                          this.$store.dispatch("layout/setOptions", { property: "live", value: options });
                          this.$store.dispatch("layout/setMenuItems", mi5);
                          EventBus.$emit("INVALIDATE");
                          this.$router.push("/prematch").catch(err => {
                            console.trace(err);
                          });
                        }
                      }
                    } else {
                      this.result = this.$t("error." + res.status);
                      if (this.$helpers.handleFeedback(res.status)) {
                      }
                    }
                  },
                  err => {
                    this.feedback.loading = false;
                    this.result = this.$t("error." + res.status);
                    if (this.$helpers.handleFeedback(err.status)) {
                    }
                  }
                );
              } else {
                this.result = this.$t("error." + res.status);
                this.$helpers.handleFeedback(res.status);
              }
            },
            err => {
              this.feedback.loading = false;
              this.result = this.$t("error." + err.status);
              this.$helpers.handleFeedback(err.status);
            }
          );
        }, 2000);
      } else {
        this.result = "Function not supported!";
      }
    },
    doSwitch(q) {
      if (q.u) {
        this.$store.dispatch("user/doSwitch", { username: q.u, password: q.st }).then(
          res => {
            this.feedback.loading = false;
            if (res.success) {
              this.feedback.loading = true;
              this.$store.dispatch("user/getBalance").then(
                res => {
                  this.feedback.loading = false;
                  if (res.success) {
                    this.$store.dispatch("layout/setRadarId", null);
                    EventBus.$emit("INVALIDATE");
                    this.$router.push("/lobby").catch(err => {
                      console.trace(err);
                    });
                  } else {
                    this.result = this.$t("error." + res.status);
                  }
                },
                err => {
                  this.feedback.loading = false;
                  this.result = this.$t("error." + res.status);
                }
              );
            } else {
              this.result = this.$t("error." + res.status);
            }
          },
          err => {
            this.feedback.loading = false;
            this.result = this.$t("error." + err.status);
          }
        );
      } else {
        this.$store.dispatch("layout/setLanguage", config.defaultLang);
        // setTimeout(() => {
        //   this.loader = false;
        //   this.loading = false;
        //   if (q.view) {
        //     // console.log("stay at home...");
        //   } else {
        //     if (this.isMobileTablet()) {
        //       var domain = this.getDomain(window.location.hostname, false);
        //       var test = "https://m." + domain;
        //       window.location.href = test;
        //     }
        //   }
        // }, 1000);
      }
    },
    doLogin(q, redirectURL) {
      // this.$store.dispatch("user/clear");
      // this.$store.dispatch("layout/reset");
      this.result = "Establish connection...";
      setTimeout(() => {
        this.result = "Authenticate user account...";
        this.$store.dispatch("layout/reset");
        this.$store.dispatch("user/doLogin", { username: q.u, password: q.p }).then(
          (res) => {
            this.feedback.loading = false;
            if (res.success) {
              this.feedback.loading = true;
              this.$store.dispatch("user/getBalance").then(
                (res) => {
                  this.feedback.loading = false;
                  if (res.success) {
                    this.$store.dispatch("layout/setRadarId", null);
                    EventBus.$emit("INVALIDATE");
                    this.$router.push("/prematch?vg=1").catch(err => {
                      console.trace(err);
                    });
                  } else {
                    this.result = this.$t("error." + res.status);
                  }
                },
                (err) => {
                  this.feedback.loading = false;
                  this.result = this.$t("error." + res.status);
                }
              );
            } else {
              this.result = this.$t("error." + res.status);
            }
          },
          (err) => {
            this.feedback.loading = false;
            this.result = this.$t("error." + err.status);
          }
        );
      }, 2000);
    },
    getDomain(url, subdomain) {
      subdomain = subdomain || false;

      url = url.replace(/(https?:\/\/)?(www.)?/i, "");

      if (!subdomain) {
        url = url.split(".");

        url = url.slice(url.length - 2).join(".");
      }

      if (url.indexOf("/") !== -1) {
        return url.split("/")[0];
      }

      return url;
    },
    isMobileTablet() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
};
</script>
